import { mapGetters } from 'vuex'

import { proxy } from '@/utils'

import { core } from '@/components/services/settingsSite/utils'

import render from './render'

export default function(options) {
  return {
    mixins: [ proxy({ type: 'array' }), core(options) ],

    computed: {
      ...mapGetters({ paymentsMethods: 'payments/methods' })
    },

    render(h) {
      return render.call(this, h, options)
    }
  }
}
